const moveAllDown = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="m11.472 8.45-3.511 3.477L4.528 8.53 3.472 9.596l4.488 4.442 4.568-4.522zm0-6L7.961 5.927 4.528 2.53 3.472 3.596 7.96 8.038l4.568-4.522z"/></svg>',
};

export { moveAllDown as default };
